import { render, staticRenderFns } from "./Events.vue?vue&type=template&id=66ad9c7b&scoped=true"
import script from "./Events.vue?vue&type=script&lang=js"
export * from "./Events.vue?vue&type=script&lang=js"
import style0 from "./Events.vue?vue&type=style&index=0&id=66ad9c7b&prod&scoped=true&lang=scss"
import style1 from "./Events.vue?vue&type=style&index=1&id=66ad9c7b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ad9c7b",
  null
  
)

export default component.exports